import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, className, delay = 0, y = 36, as = "div", ...rest }) {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8% 0px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export function MaskedLines({ lines, as = "h1", className = "", delay = 0, inView = false, ...rest }) {
  const Tag = motion[as] || motion.h1;
  const parent = inView
    ? { initial: "hidden", whileInView: "visible", viewport: { once: true, margin: "-10% 0px" } }
    : { initial: "hidden", animate: "visible" };
  return (
    <Tag className={className} {...rest}>
      {lines.map((line, i) => (
        <motion.span className="mask-line" key={i} {...parent}>
          <motion.span
            variants={{ hidden: { y: "112%" }, visible: { y: "0%" } }}
            transition={{ duration: 1.05, delay: delay + i * 0.11, ease: EASE }}
          >
            {line}
          </motion.span>
        </motion.span>
      ))}
    </Tag>
  );
}

export function Marquee({ items }) {
  const row = [...items, ...items, ...items];
  return (
    <div className="marquee" aria-hidden="true" data-testid="editorial-marquee">
      <div className="marquee-track">
        {row.map((item, i) => (
          <span className="marquee-item" key={i}>
            {item}
            <i className="marquee-dot" />
          </span>
        ))}
      </div>
    </div>
  );
}
